import {
	Button,
	Card,
	Col,
	DatePicker,
	Form,
	Input,
	Row,
	Select,
	Typography,
} from "antd";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import moment from "moment";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { addSupplierPayment } from "../../redux/actions/supplierPayment/addSupplierPaymentAction";
import PageTitle from "../page-header/PageHeader";
import axios from "axios";

const AddSupPaymentByInvoice = () => {
	const navigate = useNavigate();

	const { pid } = useParams();

	const dispatch = useDispatch();
	const { Title } = Typography;
	const { Option } = Select;

	const [form] = Form.useForm();

	let [date, setDate] = useState(moment());
	const [loader, setLoader] = useState(false);
	const [invoiceDisplay, setInvoiceDisplay] = useState(pid);

	// Fetch purchase invoice details to get supplier memo number
	useEffect(() => {
		const fetchInvoiceDetails = async () => {
			try {
				const response = await axios.get(`purchase-invoice/${pid}`);
				console.log("Purchase invoice API response:", response.data);
				// API returns: { singlePurchaseInvoice: { supplier_memo_no, ... }, status, ... }
				const invoice = response.data?.singlePurchaseInvoice;
				// Use supplier_memo_no if available, otherwise fallback to ID
				let displayValue = `#${pid}`;
				if (invoice?.supplier_memo_no) {
					displayValue = invoice.supplier_memo_no;
				}
				setInvoiceDisplay(displayValue);
				// Update form field value - keep the ID for backend submission
				form.setFieldsValue({ purchase_invoice_no: pid });
			} catch (error) {
				console.log("Error fetching invoice:", error.message);
				setInvoiceDisplay(`#${pid}`);
				form.setFieldsValue({ purchase_invoice_no: pid });
			}
		};
		fetchInvoiceDetails();
	}, [pid, form]);

	const onFinish = async (values) => {
		try {
			const data = {
				date: date,
				discount: values.discount || 0,
				...values,
			};

			const resp = await dispatch(addSupplierPayment(data));
			if (resp == "success") {
				setLoader(false);
				navigate(-1);
			}
			toast.success("Payment Successfully done");

			form.resetFields();
			setLoader(false);
		} catch (error) {
			console.log(error.message);
			setLoader(false);
		}
	};

	const onFinishFailed = (errorInfo) => {
		console.log("Failed:", errorInfo);
		setLoader(false);
	};

	const isLogged = Boolean(localStorage.getItem("isLogged"));

	if (!isLogged) {
		return <Navigate to={"/auth/login"} replace={true} />;
	}

	return (
		<>
			
			<Row className='mr-top'>
				<Col
					xs={24}
					sm={24}
					md={12}
					lg={12}
					xl={14}
					className='border rounded column-design'>
					<Card bordered={false} className='criclebox h-full'>
						<Title level={3} className='m-3 text-center'>
							Purchase Invoice Payment
						</Title>
						<Form
							form={form}
							className='m-4'
							name='basic'
							labelCol={{
								span: 8,
							}}
							wrapperCol={{
								span: 16,
							}}
							initialValues={{
								remember: true,
							}}
							onFinish={onFinish}
							onFinishFailed={onFinishFailed}
							autoComplete='off'>
							<Form.Item label='Date' required>
								<DatePicker
									defaultValue={moment()}
									onChange={(value) => setDate(value?._d)}
									style={{ marginBottom: "10px" }}
									label='date'
									name='date'
									rules={[
										{
											required: true,
											message: "Please input date!",
										},
									]}
								/>
							</Form.Item>
							<Form.Item
								style={{ marginBottom: "10px" }}
								label='Discount'
								name='discount'
								initialValue={0}>
								<Input type='number' placeholder="Enter discount (optional)" />
							</Form.Item>

							<Form.Item
								style={{ marginBottom: "10px" }}
								label='Amount'
								name='amount'
								rules={[
									{
										required: true,
										message: "Please input amount!",
									},
								]}>
								<Input type='number' />
							</Form.Item>

							<Form.Item
								style={{ marginBottom: "10px" }}
								label='Purchase Invoice No'>
								<Input 
									value={invoiceDisplay}
									disabled 
									readOnly
									style={{ color: 'rgba(0, 0, 0, 0.85)' }}
								/>
							</Form.Item>
							{/* Hidden form field to store the actual ID for backend submission */}
							<Form.Item
								name='purchase_invoice_no'
								initialValue={pid}
								hidden>
								<Input type="hidden" />
							</Form.Item>

							<Form.Item
								style={{ marginBottom: "10px" }}
								label='Payment Method'
								name='payment_method'>
								<Select placeholder="Select payment method" allowClear>
									<Option value="Cash">Cash</Option>
									<Option value="Bank Transfer">Bank Transfer</Option>
									<Option value="Cheque">Cheque</Option>
									<Option value="Credit Card">Credit Card</Option>
									<Option value="Debit Card">Debit Card</Option>
									<Option value="UPI">UPI</Option>
									<Option value="Other">Other</Option>
								</Select>
							</Form.Item>

							<Form.Item
								style={{ marginBottom: "10px" }}
								label='Reference Number'
								name='reference_number'>
								<Input placeholder="Enter reference/transaction number" />
							</Form.Item>

							<Form.Item
								style={{ marginBottom: "10px" }}
								wrapperCol={{
									offset: 8,
									span: 16,
								}}>
								<Button
									block
									type='primary'
									htmlType='submit'
									shape='round'
									loading={loader}
									onClick={() => setLoader(true)}>
									Pay Now
								</Button>
							</Form.Item>
						</Form>
					</Card>
				</Col>
			</Row>
		</>
	);
};

export default AddSupPaymentByInvoice;
